import React from "react";
import { Parser } from 'components';
const Third = (props) => {
  const {langs, cancel, nextStep} = props;
  return (
    <div>
      <div className="text-dark font-size-16 pt-32px">
        <Parser html={langs.NM_ConfirmReturnTermText}/>
      </div>
      <h2 className="text-dark font-size-16 pt-24px pt-32px  mb-48px">
        <Parser html={langs.NM_ConfirmReturnTermTitle}/>
      </h2>
      <div>
        <div className="mb-16px px-20px px-md-100px d-flex justify-content-center">
          <button className="return-item-btn-actions font-size-16 w-100 font-medium font-weight-normal py-16px btn bg-middle-gray text-dark d-block mr-12px"
            type="button" onClick={nextStep}>
            {langs.Continue}
          </button>
          <button className="return-item-btn-actions font-size-16 w-100 font-medium font-weight-normal py-16px btn bg-middle-gray text-dark d-block "
            type="button" onClick={cancel}>
            {langs.NM_Quit}
          </button>
        </div>
      </div>
    </div>
  )
}
export default Third